<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>{{ $t('StationEditContinuousCategory.editTitleMsg') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-select label="Station Category" v-model="stationCategory" :items="stationCategoriesNameList" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="submit()">
          <v-icon>done</v-icon>
          {{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" outline @click="close()">{{ $t('Button.Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const stations = createNamespacedHelpers('stations')
  const authenticate = createNamespacedHelpers('authenticate')
  const dataSources = createNamespacedHelpers('datasource')
  const app = createNamespacedHelpers('app')
  const stationManagement = createNamespacedHelpers('stationmanagement')
  const navigation = createNamespacedHelpers('navigation')
  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      station: Object,
    },
    data() {
      return {
        dialog: false,
        stationCategory: '',
        loading: false,
      }
    },
    computed: {
      ...stations.mapGetters(['stationCategoriesContinuous']),
      ...authenticate.mapGetters(['currentTenant']),
      stationCategoriesNameList() {
        return this.stationCategoriesContinuous.map(e => e.Name)
      },
    },
    methods: {
      ...dataSources.mapActions(['fetchDataSource']),
      ...app.mapActions(['setSnackbar']),
      ...stationManagement.mapActions(['editContinuousStationCategory']),
      ...navigation.mapActions(['fetchSideMenu']),
      show() {
        this.dialog = true
        this.stationCategory = this.station.LocationType
      },
      async submit() {
        this.loading = true

        const payload = {
          UserGroupId: this.currentTenant.id,
          StationId: this.station.Id,
          StationCategory: this.stationCategory,
        }

        try {
          await this.editContinuousStationCategory(payload)
          const refreshDataSource = this.fetchDataSource({
            sourceType: SOURCE_TYPES.continuousAquarius,
            sourceId: this.station.Id,
          })
          const refreshSideMenu = this.fetchSideMenu()
          await Promise.all([refreshDataSource, refreshSideMenu])
          this.close()
        } catch (error) {
          this.setSnackbar({
            text: error,
            color: 'error',
            icon: 'error',
          })
        }

        this.loading = false
      },
      close() {
        this.dialog = false
      },
    },
  }
</script>